import React, { useState } from "react";
import styles from "./styles.module.css";
import { BreedinFarmMap } from "../../breedingfarmsmap"; 
// import { Sidebar } from "../../../../components/mainsidebar/ui/buttonsNavigate";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
  height: 100%;

`;

const Content = styled.div`

`;

export const BreedinFarms = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Container>
      {/* <Sidebar collapsed={collapsed} /> */}
      <Content>
        <div className={styles.mapBackground}>
          <BreedinFarmMap latitude={41.5089324} longitude={74.724091} />
        </div>
      </Content>
    </Container>
  );
};
